<template>
  <div class="content-i">
    <div class="content-box">
      <div class=" single-page-container ">
        <div class="col-sm-6 col-md-3 pl-0 pr-0 middle middle">
          <ProductInfoBlock :product="selectedProduct" :type="'copydesk'" />
        </div>
        <div class="col-sm-9 middle">
          <div class="support-index">
            <div class="support-tickets">
              <SessionTabs :tabOptions="tabOptions" :selectedTab="selectedTab" @sessionTabInterface="changeTab" />
              <ProductOverview v-show="selectedTab == 'Overview'" :product="selectedProduct" />
              <ProductImages v-show="selectedTab == 'Assets'" :product="selectedProduct" :images="productImages" />
              <ProductWorkflow v-show="selectedTab == 'Workflow'" :comments="productComments" :history="productHistory" />
              <ProductCopy v-if="selectedTab == 'Content' && latestRevision > 0" :product="selectedProduct" :revision="latestRevision" />
              <ProductComments v-if="selectedTab == 'Comments'" :comments="productComments" />
              <ProductAssociates v-if="selectedTab == 'Associations'" :associates="productAssociates" :selectedProduct="selectedProduct" @productAssociatesInterface="handleProductAssociates"/>
              <ProductIntegration v-if="selectedTab == 'Integrations'" :integrations="productIntegrations" :product="selectedProduct" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SessionTabs from '@/components/common/SessionView/SessionTabs'
import EmptyState from '@/components/common/EmptyState'

import Product from '@/mixins/product'

import ProductInfoBlock from '@/components/productdesk/ProductInfoBlock'
import ProductTab from '@/components/photodesk/ViewSession/ProductTab'
import ProductDetails from '@/components/photodesk/ViewSession/ProductDetails'
import ProductOverview from '@/components/productdesk/ProductOverview'
import ProductImages from '@/components/productdesk/ProductImages'
import ProductWorkflow from '@/components/productdesk/ProductWorkflow'
import ProductComments from '@/components/productdesk/ProductComments'
import ProductAssociates from '@/components/productdesk/ProductAssociates'
import ProductIntegration from '@/components/productdesk/ProductIntegration'
import ProductCopy from '@/components/copydesk/ProductCopy'

export default {
  name: 'session-view',
  props: ['id_product'],
  mixins: [Product],
  components: {
    SessionTabs,
    ProductInfoBlock,
    ProductTab,
    ProductDetails,
    EmptyState,
    ProductOverview,
    ProductComments,
    ProductImages,
    ProductWorkflow,
    ProductAssociates,
    ProductIntegration,
    ProductCopy

  },
  mounted: function () {
    this.getProductDetails()
  },
  data: function () {
    return {
      tabOptions: ['Assets', 'Content', 'Overview', 'Associations', 'Comments', 'Integrations'],
      selectedTab: 'Assets',
      selectedProduct: '',
      productImages: '',
      productComments: '',
      productHistory: '',
      productRevisions: '',
      productAssociates: '',
      productIntegrations: '',
      loading: true
    }
  },
  methods: {
    getProductDetails: function () {
      var self = this

      const url = '/productdesk/product/view'
      let data = {
        id_product: self.id_product
      }

      this.$http
        .post(url, data, {
          dataType: 'json',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json'
          }
        })
        .then(function (response) {
          self.selectedProduct = response.data
          self.getProductImages()
          self.getProductComments()
          self.getProductHistory()
          self.getProductCopy()
          self.getProductAssociates()
          self.getProductIntegrations()
        })
        .catch(function (error) {
          console.log(error)
        })
    },
    changeTab: function (tab) {
      this.selectedTab = tab
    },
    formatAvatar: function (user) {
      return 'background-image: url("http://52.66.102.131' + user.avatar + '")'
    },
    updateProductDetailsContainer: function (product) {
      this.selectedProduct = product
    },
    handleProductAssociates: function (data) {
      this.getProductAssociates()
    }
  },
  computed: {
    latestRevision () {
      if (this.productRevisions) { return this.productRevisions[this.productRevisions.length - 1].id_copy_revision }
    }
  },
  watch: {
    id_product () {
      this.getProductDetails()
    }
  }
}
</script>

<style>
.table th,
.table td {
  border: none;
}
.support-index {
  display: block !important;
}
</style>
